module.exports = __webpack_public_path__ + "media/images/banner-cf-c3fea8045e7298df87300485ad7425a2.png";